import { useSelector } from 'react-redux'
import styled from 'styled-components'
import dmIconCircle from '../../assets/dmIconCircle.png'

const ButtonContainer = styled.div`
  display: block;
  position: fixed;
  bottom: ${props => (props.higher ? '100px' : '18px')};
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
`

const StyledButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37%, #ff4f7e 75%, #ff6d90 100%);
  overflow: hidden;
  border-radius: 100px;
  text-decoration: none;
  cursor: pointer;
  padding: 0 8px 0 4px;

  /* Mobile styles */
  width: 221px;
  height: 48px;

  @media (min-width: 745px) {
    /* Desktop styles */
    width: 317px;
    height: 68px;
    gap: 12px;
    box-shadow: 3px 0px 12px rgba(0, 0, 0, 0.16);
  }

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0.15)), linear-gradient(270deg, #ff9d74 0%, #ff5e6d 37%, #ff4f7e 75%, #ff6d90 100%);
  }
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  font-family: 'Helvetica Neue', -apple-system, BlinkMacSystemFont, sans-serif;

  /* Mobile styles */
  font-size: 11px;

  @media (min-width: 745px) {
    /* Desktop styles */
    font-size: 15px;
    line-height: 15px;
  }
`

const FirstLine = styled.span`
  font-weight: 500;
  white-space: nowrap;

  /* Mobile styles */
  margin-bottom: 1px;

  @media (min-width: 745px) {
    /* Desktop styles */
    margin-bottom: 4.5px;
  }
`

const SecondLine = styled.span`
  font-weight: 700;
  white-space: nowrap;
`

const IconImage = styled.img`
  border-radius: 50%;
  border: 2px solid white;
  flex-shrink: 0;

  /* Mobile styles */
  width: 24px;
  height: 24px;

  @media (min-width: 745px) {
    /* Desktop styles */
    width: 33px;
    height: 33px;
  }
`

const DiscoverButtonCTA = ({ higher }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)

  if (isAuthenticated) return null

  return (
    <ButtonContainer higher={higher}>
      <StyledButton
        onClick={() => {
          if (typeof logEvent === 'function') {
            logEvent('discover_button_cta_clicked')
          }
        }}
        href="https://decormatters.app.link/jRBbXCsXVQb"
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconImage src={dmIconCircle} alt="DecorMatters" />
        <TextContainer>
          <FirstLine>Love what you see?</FirstLine>
          <SecondLine>Start decorating your own room!</SecondLine>
        </TextContainer>
      </StyledButton>
    </ButtonContainer>
  )
}

export default DiscoverButtonCTA
